<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { HomeIcon } from '@heroicons/vue/24/outline'
import type { BreadcrumbItem } from '~/definitions/AllDefinitions'
import FlexibleDestination from '~/components/Navigation/FlexibleDestination.vue'

defineProps<{
  items: BreadcrumbItem[]
}>()
const { t } = useI18n()
</script>

<template>
  <nav
    aria-label="Breadcrumb"
    class="w-full flex text-slate-500 dark:text-slate-500"
  >
    <ol
      role="list"
      class="flex space-x-4"
    >
      <li class="flex py-3">
        <router-link
          class="flex items-center group"
          to="/"
        >
          <HomeIcon
            class="h-5 w-5 flex-shrink-0 hover:text-accent"
            aria-hidden="true"
          />
          <span class="sr-only">{{ t('HOME') }}</span>
        </router-link>
      </li>
      <li
        v-for="(item, itemIdx) in items"
        :key="itemIdx"
      >
        <div class="flex items-center">
          <svg
            class="h-full w-6 flex-shrink-0 text-slate-200 dark:text-slate-700"
            viewBox="0 0 24 44"
            preserveAspectRatio="none"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
          </svg>
          <div class="ml-4 text-sm font-medium">
            <flexible-destination
              v-if="item.path"
              :path="item.path"
              :type="item.type"
            >
              {{ item.label }}
            </flexible-destination>
            <span v-else>
              {{ item.label }}
            </span>
          </div>
        </div>
      </li>
    </ol>
  </nav>
</template>

<style scoped>

</style>
